/**
 * 创建svg用元素
 * @param name 标签名
 * @param attrs 标签属性
 * @param children 子标签
 * @returns svg相关元素或null
 */
export function svgTag(
  name = '',
  attrs: Record<string, string> = {},
  children: Array<SVGElement | null> | undefined = [],
): SVGElement | null {
  const el = document.createElementNS('http://www.w3.org/2000/svg', name);
  Object.keys(attrs).forEach((key) => {
    el.setAttribute(key, attrs[key]);
  });
  children.forEach((child) => {
    if (typeof child === 'string') {
      el.appendChild(document.createTextNode(child));
    } else if (child) {
      el.appendChild(child);
    }
  });
  return el;
}

